import React from 'react'

interface ModuleAddCardProps {
    title: string,
    description: string,
    imageSrc?: string,
    onClick?: () => void,
    idPrefix?: string
}

const ModuleAddCard: React.FC<ModuleAddCardProps> = ({title, description, imageSrc, onClick, idPrefix}) => {

    const containerRef = React.useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div
            className="odx-card odx-card--launch-tile odx-cdk-interactive !flex flex-col !pt-1 !pb-0 !mt-6 shadow-inner shadow-md"
            onClick={onClick}
            id={idPrefix ? `${idPrefix}-card` : undefined}>
            <div className="odx-card__container grow">
                <div className={"flex w-full"}>
                    <div className={"w-fit !pr-[16px]"}>
                        <odx-avatar
                            size="xxl"
                            shape="circle"
                            variant="ghost"
                            className="flex items-center justify-center"
                            style={{"--size": "48px"} as React.CSSProperties}
                            id={idPrefix ? `${idPrefix}-avatar` : undefined}
                        >
                            {imageSrc ? (
                                <img
                                    src={imageSrc}
                                    alt={`${title} icon`}
                                    className="object-cover !w-[70%] !h-[70%]"
                                />
                            ) : (
                                <odx-icon name="core::folder" size="xxl"></odx-icon>
                            )}
                        </odx-avatar>
                    </div>
                    <div className={"w-full"}>
                        <div className={"odx-card__content w-full !flex h-full"}>
                            <div className={"odx-card__title !text-3xl"} id={idPrefix ? `${idPrefix}-title` : undefined}>
                                {title}
                            </div>
                            <div className={"odx-card__subtitle"} id={idPrefix ? `${idPrefix}-description` : undefined}>
                                {description}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ModuleAddCard;
